module.exports = __webpack_public_path__ + "img/bitbucket.3cec6c86.svg";